<template>
  <div>
    <CModal
      color="primary"
      :show.sync="internalShow"
      size="xl"
      :closeOnBackdrop="false"
    >
      <template #header>
        <h5 class="text-white mb-0">
          {{ candidateDetails.full_name }} - {{ candidateDetails.display_uid }}
        </h5>
        <button aria-label="Close" class="close text-white" @click="closeModal">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </template>
      <div class="modal-body-content">
        <div class="modal-body-content">
          <table class="table table-striped table-borderless mb-0">
            <tbody>
              <tr class="font-weight-bold">
                <th class="text-primary font-weight-bold w-25">Name</th>
                <td>{{ candidateDetails.full_name }}</td>
              </tr>

              <tr class="font-weight-bold">
                <th class="text-primary">Candidate ID</th>
                <td>{{ candidateDetails.display_uid }}</td>
              </tr>

              <tr class="font-weight-bold">
                <th class="text-primary">Email</th>
                <td>{{ candidateDetails.email }}</td>
              </tr>

              <tr class="font-weight-bold">
                <th class="text-primary">Candidate Type</th>
                <td>{{ candidateDetails.candidate_type.candidate_type }}</td>
              </tr>

              <tr class="font-weight-bold">
                <th class="text-primary">Speciality</th>
                <td>{{ candidateDetails.speciality.speciality }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ProgressStepper
          :steps="steps"
          v-model="currentStepKey"
          :completeAll="actions.length === 0"
        >
          <template
            v-for="step in [
              'matched',
              'shortlisted',
              'submitted',
              'interview',
              'offered',
              'onboarded',
            ]"
            #[step]
          >
            <div class="mt-3">
              <div class="row g-2 justify-content-center">
                <div
                  v-for="action in actions"
                  :key="action.action_id"
                  class="col-12 col-sm-6 col-md-4 col-lg-3 status-option"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center py-2 mb-2"
                    @click="onOptionClick(action)"
                  >
                    <span class="text-truncate">{{ action.label }}</span>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </ProgressStepper>
      </div>
    </CModal>
  </div>
</template>

<script>
import Stepper from "../../components/reusable/bars/stepper.vue";
import ProgressStepper from "../../components/reusable/ProgressStepper.vue";

export default {
  props: {
    isShowPopup: Boolean,
    selectedTabIndex: Number,
    candidateDetails: Object,
    candidateStatus: Object,
    actions: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    Stepper,
    ProgressStepper,
  },

  data() {
    return {
      internalShow: this.isShowPopup,
      currentStepKey: "",
      stepKeyMap: [
        "matched",
        "shortlisted",
        "submitted",
        "interview",
        "offered",
        "onboarded",
      ],
      steps: [
        {
          key: "matched",
          label: "Matched",
          icon: "fas fa-user-check",
        },
        {
          key: "shortlisted",
          label: "Shortlisted",
          icon: "fas fa-list-check",
        },
        {
          key: "submitted",
          label: "Submitted",
          icon: "fas fa-paper-plane",
        },
        {
          key: "interview",
          label: "Interview",
          icon: "fas fa-calendar-check",
        },
        {
          key: "offered",
          label: "Offer Made",
          icon: "fas fa-handshake",
        },
        {
          key: "onboarded",
          label: "Onboarded",
          icon: "fas fa-user-tie",
        },
      ],
    };
  },

  watch: {
    isShowPopup(newVal) {
      this.internalShow = newVal;
    },
  },

  methods: {
    closeModal() {
      this.internalShow = false;
      this.$emit("update:isShowPopup", false);
    },
    onOptionClick(action) {
      this.$emit("openActionModal", action);
    },
  },

  mounted() {
    const status = this.candidateStatus.status.toLowerCase().trim();

    if (status === "review (shortlist 2)") {
      this.currentStepKey = this.stepKeyMap[1];
    } else if (status === "on boarding") {
      this.currentStepKey = this.stepKeyMap[5];
    } else {
      this.currentStepKey = status;
    }
  },
};
</script>

<style scoped>
::v-deep .modal-footer {
  display: none !important;
}

.status-option .btn {
  min-height: 44px;
}
.status-option .text-truncate {
  overflow: visible;
}

@media (max-width: 576px) {
  .status-option {
    padding-left: 6px;
    padding-right: 6px;
  }
  .status-option .btn {
    font-size: 0.9rem;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
